import React from "react";
import Lottie from 'react-lottie';

const Animation = ({animationData, height, width, style, isLoop}) => {

  if (!animationData) return (null);

  const defaultOptions = {
    loop: isLoop,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Lottie options={defaultOptions}
          height={height || 400}
          width={width}
          style={style}
    />
  );
}

export default Animation;